import React from 'react';
import Select from 'react-select';
import Toaster from 'toastr';
import { connect } from 'react-redux';
import { Permissioned } from 'react-permissions';
import Messages from '../../../configurations/messages';
import Permissions from '../../../configurations/permissions';
import Util from '../../../util/util';
import ArbiterApi from '../../../api/ArbiterApi';
import Modal from '../../common/modal';
import FloatInput from '../../common/floatInput';
import CButton from '../../common/connectedButton';

class DisputeRegionsModal extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            isNew: props.isNew,
            isView: !props.isNew,
            disputeRegion: props.isNew ? {} : props.disputeRegion,
            periodType : null,
            title: props.isNew ? "New Dispute Region" : `${props.disputeRegion.name}`,
            updating: false,
            touchedForm: false,
            nameValidity: -1,
            periodTypeValidity: -1,

        };
        this.periodTypes =  [{ label : "BUSINESS_DAY", value : "BUSINESS_DAY"}, {label : "CALENDAR_DAY",  value : "CALENDAR_DAY"}];

        this.modalStyle = {
            ovelay: {},
            content: {
                top: "80px",
                left: "250px",
                right: "250px",
                bottom: "180px",
                zIndex: "1000"
            }
        }
        this.onTextInputChange = this.onTextInputChange.bind(this);
        this.onPeriodTypeChange = this.onPeriodTypeChange.bind(this);
       
    }

    componentDidMount(){
        if(!this.state.isNew){
            this.periodTypes.forEach((p) =>{
                if(this.state.disputeRegion.periodType === p.value){
                    this.setState({periodType : p});
                }
            })
        }
    }

    onTextInputChange(evt) {

        let id = evt.target.id;
        let disputeRegion = Object.assign({}, this.state.disputeRegion);
        disputeRegion[id] = evt.target.value || null;

        let stateUpdate = {
            disputeRegion,
            touchedForm: true
        }
        stateUpdate[id + "Validity"] =  evt && evt.target.value ? 1 : 0;

        this.setState(stateUpdate);
    }
    onPeriodTypeChange(evt) {
        let disputeRegion = Object.assign({}, this.state.disputeRegion);
        disputeRegion.periodType = evt ? evt.value : null;

        this.setState({
            disputeRegion,
            periodType: evt,
            touchedForm: true,
            periodTypeValidity: evt ? 1 : 0
        });
    }
       
    handleAction(evt) {
        this.setState({ updating: true });

        const disputeRegion = this.state.disputeRegion;
        const isNew = this.state.isNew;
        let promise = this.state.isNew ? ArbiterApi.createDisputeRegion(disputeRegion) : ArbiterApi.updateDisputeRegion(disputeRegion.id, disputeRegion)
        promise.then((response) => {
            Toaster.success(`Dispute Region  '${this.state.disputeRegion.name}' - successfully  ${isNew ? 'created' : 'updated'}`);
            this.setState({ updating: false });
            this.props.onRequestClose(evt, true);
        })
            .catch((error) => {
                console.log(error);
                Toaster.error(`${error.data ? error.data.description : error.statusText}`, `${Messages.ERROR_DISPUTE_REGION_UPDATE} - ${error.status}`);
                this.setState({ updating: false });
            })
    }


    render() {
        const isNew = this.state.isNew;
        const isView = this.state.isView;
        return (
            <Modal title={this.state.title} isOpen={this.props.isOpen} style={this.modalStyle} onRequestClose={this.props.onRequestClose}>
                {isView &&
                    <div className="mod-content">
                        <form>
                            <div className="row">
                                <div className="col-md-11">
                                    <div className="form-div">
                                        <label>Name :</label>
                                        <label>{this.state.disputeRegion.name}</label>
                                    </div>
                                    <div className="form-div">
                                        <label>Period Type :</label>
                                        <label>{this.state.disputeRegion.periodType}</label>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                }
                {!isView && 
                <div className="mod-content">
                    <form>
                        <div className="row">
                            <div className="col-md-11">
                                <div className="form-div">
                                    <label>Name :</label>
                                    <FloatInput
                                        id="name"
                                        value={this.state.disputeRegion.name}
                                        onChange={this.onTextInputChange}
                                        placeholder="Enter Name"
                                        showError={this.state.nameValidity === 0} errorMessage={`${Messages.INVALID_NAME}`}
                                    />
                                </div>

                                <div className="form-div">
                                    <label>Period Type :</label>
                                    <Select
                                        id="periodType"
                                        value={this.state.periodType}
                                        options={this.periodTypes}
                                        onChange={this.onPeriodTypeChange}
                                        placeholder="Select Period Type"
                                    />
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                }
                <div className="mod-footer">
                    <div className="mod-footer-buttons">
                        {isView &&
                            <CButton 
                                onClick={(evt) => { this.setState({isView : false}) }} 
                                className="btn btn-primary"
                                allowedPermissions={[Permissions.UPDATE_DISPUTE_REGION]}>EDIT</CButton>
                        }
                        {!isView && isNew &&
                            <CButton 
                                onClick={(evt) => { this.handleAction(evt); }} 
                                disabled={this.state.updating || !this.formValid()} 
                                className="btn btn-primary"
                                allowedPermissions={[Permissions.CREATE_DISPUTE_REGION]}>CREATE</CButton>

                        }
                        {!isView && !isNew &&
                            <CButton 
                                onClick={(evt) => { this.handleAction(evt); }} 
                                disabled={this.state.updating || !this.formValid()} 
                                className="btn btn-primary"  
                                allowedPermissions={[Permissions.UPDATE_DISPUTE_REGION]}>UPDATE</CButton>

                        }
                        <button onClick={(evt) => { this.props.onRequestClose(evt); }} disabled={this.state.updating} className="btn btn-danger">CLOSE</button>
                    </div>
                </div>
            </Modal>
        )
    }

    formValid() {
        if (this.state.isNew)
            //Each field must have an exact validity i.e. validity must exact equal '1'
            return this.state.touchedForm && this.state.nameValidity === 1 && this.state.periodTypeValidity === 1;
        //all fields must be valid i.e validity must be 1 or -1 (for untouched fields)
        return this.state.touchedForm && this.state.nameValidity && this.state.periodTypeValidity;
    }

}

export default connect(Util.defaultMapStateToProps)(Permissioned(DisputeRegionsModal, [Permissions.VIEW_DISPUTE_REGION]));


// WEBPACK FOOTER //
// ./src/components/admin/disputeRegions/disputeRegionsModal.js